// import { useTheme } from '@mui/material';
// import { useEffect } from 'react';

// const FaviconWithBadge: React.FC<{ unreadCount: number }> = ({ unreadCount = 0 }) => {
//   const theme = useTheme();

//   useEffect(() => {
//     const updateFavicon = (count: number) => {
//       const favicon: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
//       const faviconUrl = favicon ? favicon.href : '/favicon.ico';

//       const canvas = document.createElement('canvas');
//       const img = document.createElement('img');

//       img.onload = () => {
//         canvas.width = img.width;
//         canvas.height = img.height;
//         const ctx = canvas.getContext('2d');
//         if (!ctx) return;
//         ctx.drawImage(img, 0, 0);

//         if (count > 0) {
//           ctx.fillStyle = 'red';
//           ctx.beginPath();
//           ctx.arc(canvas.width - 16, canvas.height - 16, 16, 0, 2 * Math.PI);
//           ctx.fill();

//           ctx.fillStyle = 'white';
//           ctx.font = '700 25px Heebo';
//           ctx.textAlign = 'center';
//           ctx.textBaseline = 'middle';
//           ctx.fillText(count > 99 ? '99+' : count.toString(), canvas.width - 17, canvas.height - 13);
//         }

//         const newFavicon = canvas.toDataURL('image/png');
//         if (favicon) favicon.href = newFavicon;
//       };

//       img.src = faviconUrl;
//     };

//     updateFavicon(unreadCount);
//   }, [unreadCount]);

//   return null;
// };

// export default FaviconWithBadge;

import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'store';
import { getImageUrl } from 'utils/getImageUrl';

interface FaviconWithBadgeProps {}

const FaviconWithBadge: React.FC<FaviconWithBadgeProps> = React.memo(() => {
  const theme = useTheme();
  const newIconColor = theme.palette.secondary.main;

  const unreadChatUsers = useSelector((state) => state.unreadChatUsers);
  const unreadCount = unreadChatUsers.length;

  useEffect(() => {
    // Upload existing favicon
    const faviconUrl = getImageUrl('icon-logo.svg');
    fetch(faviconUrl)
      .then((response) => response.text())
      .then((svgText) => {
        // const modifiedSvgText = svgText.replace(/__PRIMARY_COLOR__/g, primaryColor);
        const modifiedSvgText = svgText.replace('#2a3847', newIconColor);

        // Generate URL based on SVG
        const svgDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(modifiedSvgText);

        const faviconLink = document.querySelector("link[rel='icon']") as HTMLLinkElement;
        const canvas = document.createElement('canvas');
        const img = document.createElement('img');

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          if (!ctx) return;
          ctx.drawImage(img, 0, 0);

          if (unreadCount > 0) {
            // Generate badge
            ctx.fillStyle = 'red';
            ctx.beginPath();
            ctx.arc(canvas.width - 16, canvas.height - 14, 16, 0, 2 * Math.PI);
            ctx.fill();

            // Print text inside
            ctx.fillStyle = 'white';
            ctx.font = '700 22px Tahoma';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(
              unreadCount > 99 ? '99+' : unreadCount.toString(),
              canvas.width - 17,
              canvas.height - 12,
            );
          }

          // Update favicon
          const newFavicon = canvas.toDataURL('image/png');
          if (faviconLink) {
            faviconLink.href = newFavicon;
          }
        };
        img.src = svgDataUrl;
      })
      .catch((error) => {
        console.error('Error loading favicon.svg:', error);
      });
  }, [unreadCount, newIconColor]);

  return null;
});

export default FaviconWithBadge;
